import { createCanvas } from "../../include/module";
createCanvas();

import { detectScroll } from "../../include/module";
detectScroll();

import { toggleHeader } from "../../include/module";
toggleHeader();

import { anchorLink } from "../../include/module";
anchorLink();

const toggleQA = () => {
  const targetButtons       = document.querySelectorAll('.rec-QA_MainList_Item_Button');
  const targetContents      = document.querySelectorAll('.rec-QA_MainList_Item_Content');
  const targetButtonsArray  = Array.prototype.slice.call(targetButtons,0);
  const targetContentsArray = Array.prototype.slice.call(targetContents,0);
  targetButtonsArray.forEach((targetButton, index) => {
    targetButton.addEventListener('click', () => {
      if (targetButton.classList.contains('is-Closed')) {
        targetButton.classList.remove('is-Closed');
        targetContentsArray[index].classList.remove('is-Closed-H');
        targetContentsArray[index].classList.remove('is-Closed-O');
      } else {
        targetButton.classList.add('is-Closed');
        targetContentsArray[index].classList.add('is-Closed-O');
        targetContentsArray[index].classList.add('is-Closed-H');
      }
    }, false);
  });
}
toggleQA();



// WEBPACK FOOTER //
// script.js